import { ApolloError } from '@apollo/client';

export type RecruitmentApiErrorType =
  | 'CsvHeaderInvalidError'
  | 'JobNotFoundError'
  | 'UnauthorizedException'
  | 'InternalError'
  | string;

export interface RecruitmentApiErrorInfo {
  missingColumns?: string[];
  missingRequiredColumns?: string[];
  requiredColumns?: string[];
  [key: string]: unknown;
}

export interface ParsedRecruitmentApiError {
  errorType?: RecruitmentApiErrorType;
  errorInfo?: RecruitmentApiErrorInfo;
  message?: string;
}

export const parseRecruitmentApiError = (
  error: ApolloError
): ParsedRecruitmentApiError => {
  const graphQLError = error.graphQLErrors?.[0] as any;

  return {
    errorType: graphQLError?.errorType || graphQLError?.extensions?.errorType,
    errorInfo: graphQLError?.errorInfo || graphQLError?.extensions?.errorInfo,
    message: graphQLError?.message || error.message,
  };
};
